var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDuplicateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20310_14749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8V12",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H12",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.3335H6.66659C5.93021 5.3335 5.33325 5.93045 5.33325 6.66683V13.3335C5.33325 14.0699 5.93021 14.6668 6.66659 14.6668H13.3333C14.0696 14.6668 14.6666 14.0699 14.6666 13.3335V6.66683C14.6666 5.93045 14.0696 5.3335 13.3333 5.3335Z",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 10.6668C1.93325 10.6668 1.33325 10.0668 1.33325 9.3335V2.66683C1.33325 1.9335 1.93325 1.3335 2.66659 1.3335H9.33325C10.0666 1.3335 10.6666 1.9335 10.6666 2.66683",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20310_14749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDuplicateIcon);
export default __webpack_public_path__ + "static/media/copy-duplicate-icon.c531dbd80207e8bdfbd52a567faeca4b.svg";
export { ForwardRef as ReactComponent };